import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import axios from 'axios';
import './index.css';
import App from './App';
import { AuthProvider } from './components/hooks/AuthContext';

// Send the admin's token with every call to our API. Individual services set the
// header on some calls and not others, which made authenticated endpoints (e.g.
// deleting a join request) fail with "Authentication credentials were not provided".
axios.interceptors.request.use((config) => {
  const url = config.url || '';
  const isOurApi = url.includes('api.jamboricg.com')
    || url.includes('127.0.0.1:8000')
    || url.includes('localhost:8000')
    || url.startsWith('/api');
  const token = localStorage.getItem('token') || localStorage.getItem('authToken');
  if (isOurApi && token && !config.headers?.Authorization) {
    config.headers = { ...config.headers, Authorization: `Token ${token}` };
  }
  return config;
});

// Create a QueryClient instance
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>
);
